import { findItem, findItems } from '@jswork/tree-utils';

interface ParseRegionTagsOptions {
  region_tags: any[];
  preference_tags: Record<string, any>;
}

interface RegionTagItem {
  region: string;
  type: string;
  key: string;
  value: string;
}

const REGION_HOOKS = {
  'COMMONWEALTH': 'CO',
};

const TREE_OPTS = { children: 'data' };

class RegionTags {
  static toArray(options: ParseRegionTagsOptions) {
    const { region_tags, preference_tags } = options;
    const result: RegionTagItem[] = [];
    for (const region in preference_tags) {
      for (const type in preference_tags[region]) {
        for (const key in preference_tags[region][type]) {
          const value = preference_tags[region][type][key];
          // const regionValue = REGION_HOOKS[region] || region;
          const keyItem = findItem(region_tags, key, TREE_OPTS);
          const valueItems = findItems(region_tags, value, TREE_OPTS);
          if (valueItems.length) {
            result.push({
              region,
              type,
              key: keyItem?.label,
              value: valueItems.map((v) => v.label).join(', '),
            });
          }
        }
      }
    }
    return result;
  }
}


export default RegionTags;
